export default defineNuxtPlugin(() => {
  return {
    provide: {
      payloadApi: $fetch.create<PayloadApiResponse>({
        baseURL: payloadApiBase(),
      }),
    },
  }
})
